import { ErrorBoundary } from '../shared/ErrorBoundary';
import { useClubCalendar } from '../../hooks/useClubCalendar';
import { format, parseISO } from 'date-fns';
import { CalendarIcon } from '@heroicons/react/24/outline';
import { useUserProfile } from '../../hooks/useUserProfile';

export const ClubCalendarPanel = () => {
  const { events, isLoading, error } = useClubCalendar();
  const { profile } = useUserProfile();
  
  // Get club name for the panel title
  const clubName = profile?.clubName || 'Club';

  return (
    <ErrorBoundary>
      <div className="bg-[#121212] rounded-lg shadow-lg p-4 transition-colors">
        <h2 className="text-xl font-bold mb-4 text-[#CECFD2] flex items-center">
          <CalendarIcon className="h-5 w-5 mr-2 text-[#4E46FF]" />
          {clubName} Fixtures
        </h2>

        {isLoading ? (
          <div className="flex justify-center items-center h-20">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-[#4E46FF]" />
          </div>
        ) : error ? (
          <div className="text-red-500 text-sm p-2 text-center">{error}</div>
        ) : events && events.length > 0 ? (
          <div className="space-y-3 max-h-[200px] overflow-y-auto">
            {events.map((event) => (
              <div
                key={event.id}
                className="flex items-center space-x-2 p-3 border border-gray-700 hover:bg-[#26222E] rounded-md transition-colors"
              >
                <div className="flex-shrink-0 flex items-center space-x-1">
                  <span className="font-medium text-[#4E46FF]">
                    {format(parseISO(event.date), 'MMM d')}
                  </span>
                  <span className="text-gray-500">
                    {format(parseISO(event.date), 'HH:mm')}
                  </span>
                </div>
                <div className="flex-1 truncate text-[#CECFD2]">
                  {event.description}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="h-20 flex items-center justify-center">
            <p className="text-[#CECFD2] text-sm">No upcoming fixtures</p>
          </div>
        )}
      </div>
    </ErrorBoundary>
  );
};